import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
} from '../models/Theme.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CoroutineScopeHelpers1j3li0lv9e54a as CoroutineScopeHelpers } from '../../../../../reactive/com/lightningkite/reactive/context/CoroutineScopeHelpers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../ViewWrapper.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ViewWriter$split$r$1Class;
function ViewWriter$split$r$1() {
  if (ViewWriter$split$r$1Class === VOID) {
    class $ extends ViewWriter() {
      constructor(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.rd9_1 = this$0;
        super($box);
        this.pd9_1 = this$0;
        this.qd9_1 = this$0.pc().tb3();
      }
      pc() {
        return this.qd9_1;
      }
      tba(view) {
        return this.rd9_1.tba(view);
      }
      rba(view) {
        return this.rd9_1.rba(view);
      }
      ga2() {
        return this.pd9_1.ga2();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ViewWriter(), CoroutineScope()]);
    ViewWriter$split$r$1Class = $;
  }
  return ViewWriter$split$r$1Class;
}
var _no_name_provided__qut3ivClass;
function _no_name_provided__qut3iv() {
  if (_no_name_provided__qut3ivClass === VOID) {
    class $ {
      constructor($this_onNext) {
        this.sd9_1 = $this_onNext;
      }
      hd1(theme) {
        return this.sd9_1.ab1_1;
      }
    }
    protoOf($).abf = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    _no_name_provided__qut3ivClass = $;
  }
  return _no_name_provided__qut3ivClass;
}
var ViewWriterClass;
function ViewWriter() {
  if (ViewWriterClass === VOID) {
    class $ extends CoroutineScopeHelpers() {
      constructor($box) {
        super($box);
        this.dbb_1 = null;
        this.ebb_1 = null;
      }
      rba(view) {
      }
      tb3() {
        var r = new (ViewWriter$split$r$1())(this);
        r.dbb_1 = this.dbb_1;
        r.ebb_1 = this.ebb_1;
        this.dbb_1 = null;
        this.ebb_1 = null;
        return r;
      }
      fbb(view) {
        var tmp0_elvis_lhs = this.ebb_1;
        var p = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
        p.rba(view);
        this.ebb_1 = view;
        var tmp1_safe_receiver = this.dbb_1;
        if (tmp1_safe_receiver == null)
          null;
        else
          tmp1_safe_receiver(view);
        this.dbb_1 = null;
        view.bbb();
        p.tba(view);
      }
      gbb(p, view) {
        p.rba(view);
        this.ebb_1 = null;
        var tmp0_safe_receiver = this.dbb_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver(view);
        this.dbb_1 = null;
      }
      hbb(p, view) {
        view.bbb();
        p.tba(view);
      }
      ibb(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = this.dbb_1;
        var tmp = this;
        tmp.dbb_1 = (_this__u8e3s4_0) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4_0);
          // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
          Companion_getInstance();
          var tmp$ret$0 = new (_no_name_provided__qut3iv())(_this__u8e3s4);
          _this__u8e3s4_0.lba(tmp$ret$0);
          return Unit_instance;
        };
        Companion_getInstance_0();
        return Companion_getInstance_0();
      }
      jbb(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = this.dbb_1;
        var tmp = this;
        tmp.dbb_1 = (_this__u8e3s4_0) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4_0);
          var old = _this__u8e3s4_0.qb6_1;
          _this__u8e3s4_0.lba(old.abf(_this__u8e3s4));
          return Unit_instance;
        };
        Companion_getInstance_0();
        return Companion_getInstance_0();
      }
      kbb(_this__u8e3s4, view) {
        return !(_this__u8e3s4 === Companion_getInstance_0()) ? _this__u8e3s4 : view;
      }
      lbb(_this__u8e3s4, view) {
        var tmp0_elvis_lhs = _this__u8e3s4.rcu();
        return tmp0_elvis_lhs == null ? view : tmp0_elvis_lhs;
      }
    }
    initMetadataForClass($, 'ViewWriter');
    ViewWriterClass = $;
  }
  return ViewWriterClass;
}
//region block: exports
export {
  ViewWriter as ViewWriter2xfqkrnuqv5cx,
};
//endregion

//# sourceMappingURL=ViewWriter.mjs.map
